import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import AutoresponderListContainer from "./AutoresponderListContainer";
import RoundActionIcon from "components/buttons/RoundActionIcon";
import SectionTitle from "components/text/SectionTitle";

import returnIcon from "assets/img/icons/return-icon.svg";
import autoresponderIcon from "assets/img/icons/icons8-reply.svg";
import newTabIcon from "assets/img/icons/Expand-Window.svg";

const Autoresponders = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackIconWrap = styled.div``;

const ButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
`;

const ManageLeadsBox = styled.div`
  position: relative;
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const TitleIcon = styled.div`
  display: inline-block;
  padding-right: 6px;

  transform: translateY(4.5px);

  width: 28px;
  min-width: 28px;
`;

const Text = styled.div`
  line-height: 130%;
`;

const ExternalLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;

  text-decoration: none;
`;

const ExternalLinkText = styled.div`
  color: ${css.LIGHT_BLUE};
`;

const ExternalLinkIcon = styled.div`
  padding-top: 2px;

  width: 11px;
  min-width: 11px;
`;

export default () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const from = searchParams.get("from") ? searchParams.get("from") : null;

  // set page Title
  useEffect(() => {
    document.title = "Autoresponders | Scalelup";
  }, []);

  let returnTo = "/marketing-tools";

  if (from === "mailing-list") {
    const listId = searchParams.get("listId")
      ? searchParams.get("listId")
      : null;

    if (listId) returnTo = `/mailing-list?id=${listId}`;
  }
  return (
    <Layout>
      <Autoresponders>
        <Header>
          <PageTitle>Autoresponders</PageTitle>
          <BackIconWrap>
            <RoundActionIcon
              icon={returnIcon}
              iconSize="16px"
              iconAlt="Return"
              onClick={() => navigate(returnTo)}
            />
          </BackIconWrap>
        </Header>
        <ManageLeadsBox>
          <TopContent>
            <Heading>
              <BoxTitle>
                <TitleIcon>
                  <img src={autoresponderIcon} style={{ width: "100%" }} />
                </TitleIcon>
                Automated Email Follow-Ups
              </BoxTitle>
              <Text>
                Automate your email communication with Scalelup autoresponders.
                Here, you can manage autoresponder sequences linked to your
                mailing lists. Set up a welcome message and a series of
                follow-up emails that will be automatically sent to your
                verified leads.
              </Text>
              <ExternalLink
                to="https://help.scalelup.com/en/collections/15360928-autoresponders"
                target="_blank"
              >
                <ExternalLinkText>
                  Learn more about Autoresponders
                </ExternalLinkText>
                <ExternalLinkIcon>
                  <img src={newTabIcon} style={{ width: "100%" }} />
                </ExternalLinkIcon>
              </ExternalLink>
            </Heading>
          </TopContent>
        </ManageLeadsBox>
        <SectionTitle>Autoresponders</SectionTitle>
        <AutoresponderListContainer />
      </Autoresponders>
    </Layout>
  );
};
